<template>
  <Dashboard title="Coach Routine">
    <div v-if="loading" class="flex justify-center items-center h-full w-full">
      <Loader />
    </div>
  </Dashboard>
</template>

<script setup>
// Grab the user's coach routines
// Redirect to the 15-minute one
import axios from 'axios';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Dashboard from '../../components/layouts/DashboardLayout.vue';
import Loader from '../../components/General/Loader.vue';

const router = useRouter();
const loading = ref(true);

function getMyRoutines() {
  loading.value = true;
  axios.get('/task_lists/my_daily_routine').then((res) => {
    const { data } = res;
    // Redirect to the first one (shortest)
    if (data.length > 0) {
      data.sort((a, b) => a.duration_minutes - b.duration_minutes);
      router.push(`/routines/${data[0].slug}`);
    } else {
      loading.value = false;
    }
  });
}

onMounted(() => {
  getMyRoutines();
});
</script>
